import { ActionKeys } from '~/actions/constants';
import * as labelsSettingsAction from '~/actions/labels-settings.actions';
import { fetchServiceLevelsByAccount } from '~/actions/providers.actions';
import * as userActions from '~/actions/user.actions';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  JSONLabelSetting,
  labelSettingsFromJSON,
  labelSettingsToJSONv2,
} from '~/types/LabelSettings';
import settingsService from '../../services/settings.service';

export function* fetchLabelSettings() {
  try {
    const response: AxiosResponse<JSONLabelSetting> = yield call([
      settingsService,
      settingsService.fetchLabelSettings,
    ]);

    const responsePayload = labelSettingsFromJSON(response.data);

    yield put(labelsSettingsAction.fetchLabelSettingsSuccess(responsePayload));
  } catch (err) {
    // Continue with error.
  }
}

export function* saveLabelSettings(
  action: ReturnType<typeof labelsSettingsAction.submitLabelsForm>,
) {
  try {
    const formPayload = labelSettingsToJSONv2(action.payload.formData);

    const response: AxiosResponse = yield call(
      [settingsService, settingsService.saveLabelSettings],
      formPayload,
    );

    // Current endpoint in go doesn't support saving default service level
    // Since they don't match between the db and the list the UI its getting from django
    // Need to save it in a different call to /account :/

    const serviceLevelResponse: AxiosResponse = yield call(
      settingsService.saveDefaultServiceLevel,
      formPayload.default_outbound_service_level,
      formPayload.default_return_service_level,
    );

    if (formPayload.default_provider && formPayload.default_outbound_service_level) {
      yield put(
        userActions.updateUserDefaultServiceLevel(
          formPayload.default_provider,
          formPayload.default_outbound_service_level,
        ),
      );
    }

    if (formPayload.default_return_provider && formPayload.default_return_service_level) {
      yield put(
        userActions.updateUserDefaultReturnServiceLevel(
          formPayload.default_return_provider,
          formPayload.default_return_service_level,
        ),
      );
    }

    if (formPayload.default_outbound_service_level || formPayload.default_return_service_level) {
      // update the Service Levels by Account in the store to reflect which service levels are marked "is_used"
      yield call(fetchServiceLevelsByAccount);
    }

    response.data.default_provider = serviceLevelResponse.data.default_provider;
    response.data.default_service_level = serviceLevelResponse.data.default_service_level;

    const responsePayload = labelSettingsFromJSON(response.data);

    yield put(labelsSettingsAction.didSaveLabel(responsePayload));
    yield put(userActions.refreshUser());
  } catch (err) {
    yield put(userActions.refreshUser());
  }
}

export function* fetchPreviewLink(
  action: ReturnType<typeof labelsSettingsAction.fetchPreviewLink>,
) {
  try {
    const response: AxiosResponse = yield call(
      [settingsService, settingsService.fetchPreviewLink],
      action.payload.labelLogoType,
    );
    if (response.data['url']) {
      window.open(response.data['url'], '_blank');
    }
  } catch (err) {
    // Continue with error.
  }
}

export default [
  takeLatest(ActionKeys.SAVE_LABEL_SETTINGS, saveLabelSettings),
  takeLatest(ActionKeys.FETCH_LABEL_SETTINGS, fetchLabelSettings),
  takeLatest(ActionKeys.FETCH_LABEL_PREVIEW_LINK, fetchPreviewLink),
];
